export const miscTailHc = {
  maquetaCreateNav: {
    guidesAria: "Guías y ayuda en vídeo",
    guidesTip: "Guías y ayuda",
    availabilityPricesTitle: "Disponibilidad & Tarifas",
    hotelCalendarSubtitle: "Disponibilidad y reservas por habitación",
    availabilityPricesSubtitle: "Precios, disponibilidad y estancia mínima",
  },
  maquetaNav: {
    guidesAria: "Guías y ayuda en vídeo",
    guidesTip: "Guías y ayuda",
    novedadesAria: "Novedades del sistema",
    novedadesTip: "Novedades",
    tourTip: "Novedades: recorrido guiado",
    tourAria: "Abrir el recorrido de novedades",
    backToPanel: "Volver al panel",
    accountTitle: "Configuración de la cuenta",
    agentIaTitle: "Agente IA",
    directBookingsTitle: "Reservas directas",
    listingsTitle: "Configuración de anuncios",
  },
  navMovil: {
    menuTitle: "Menu",
    home: "Home",
    calendar: "Calendario",
    reservations: "Reservas",
    checkins: "Check-ins",
    housekeeping: "Limpieza",
    channels: "Canales de reservas",
    settings: "Configuración",
    settingsDesktopOnly: "Disponible solo en versión escritorio",
    experiences: "Experiencias",
  },
  register: {
    terms: "Reglamento",
    privacy: "Política de privacidad",
    loginError: "Error al iniciar sesión.",
  },
  buttonSave: {
    savingRoom: "Guardando habitación...",
  },
  firstForm: {
    name: "Nombre",
    phone: "Teléfono",
  },
  final: {
    guestsRegistered: "Huéspedes registrados",
    registrationsCompleted: "Registros completados",
    registrationTime: "Hora del registro : ",
    shareRegistrationLink: "Compartir link de registro",
  },
  scannerPdf417: {
    captureCode: "Capturar codigo",
    focusInstruction: "Enfoque y capture el código de barra de su cédula",
  },
  configNotifications: {
    title: "Notificaciones",
    propertyLabel: "Propiedad",
    phoneInstruction: "Ingresa el número de teléfono que deseas utilizar para recibir las notificaciones de solicitudes de servicio o Check-Ins realizados por los huéspedes a través de WhatsApp",
    saveWhatsapp: "Guardar WhatsApp",
    editWhatsapp: "Editar WhatsApp",
    configTitle: "Configuración",
    serviceNotifications: "Notificaciones de servicios",
    checkinNotifications: "Notificaciones de Check-In",
    active: "Activas",
    inactive: "Inactivas",
    whatsappRequired: "Debes ingresar el WhatsApp",
    swalTitle: "WhatsApp para notificaciones de tu propiedad",
    swalText: "Recibirás todas las notificaciones de los servicios solicitados y Check-In de los huéspedes ",
    cancel: "Cancelar",
    whatsappAdded: "WhatsApp agregado con éxito",
  },
  modalPoliceData: {
    headerSub: "Introduce tus credenciales de acceso al sistema",
    closeAria: "Cerrar",
    entityName: "Nombre de la entidad",
    usernamePlaceholder: "Ingresa tu usuario",
    passwordPlaceholder: "Ingresa tu contraseña",
    hide: "Ocultar",
    show: "Mostrar",
    lessorExample: "Ej: 12345",
    establishmentExample: "Ej: 67890",
    saving: "Guardando…",
    listingNotFound: "No se encontró el anuncio asociado.",
    saveFailed: "No se pudo guardar SES Hospedajes.",
  },
  notificaciones: {
    title: "Notificaciones",
    propertyLabel: "Propiedad",
    phoneInstruction: "Ingresa el número de teléfono que deseas utilizar para recibir las notificaciones de solicitudes de servicio o Check-Ins realizados por los huéspedes a través de WhatsApp",
    saveWhatsapp: "Guardar WhatsApp",
    editWhatsapp: "Editar WhatsApp",
    configTitle: "Configuración",
    serviceNotifications: "Notificaciones de servicios",
    checkinNotifications: "Notificaciones de Check-In",
    active: "Activas",
    inactive: "Inactivas",
    whatsappRequired: "Debes ingresar el WhatsApp",
    swalTitle: "WhatsApp para notificaciones de tu propiedad",
    swalText: "Recibirás todas las notificaciones de los servicios solicitados y Check-In de los huéspedes ",
    cancel: "Cancelar",
    whatsappAdded: "WhatsApp agregado con éxito",
  },
  admins: {
    listTitle: "Listado Managers",
    newManager: "Nuevo Manager",
    today: "Hoy",
    thName: "Nombre",
    thEmail: "Email",
    thRegistered: "Registrado",
    edit: "Editar",
    delete: "Eliminar",
    userLabel: "Usuario",
    emailLabel: "Correo",
    passwordLabel: "Contraseña",
    cancel: "Cancelar",
    save: "Guardar",
    createdOk: "Creado correctamente",
    requestError: "Error de solicitud",
    updatedOk: "Actualizado correctamente",
    deletedOk: "Eliminado correctamente",
  },
};
